export default {
    loading: "Загрузка...",
    too_many_requests: "Ваш поиск ограничен. Зарегистрируйте аккаунт чтобы обойти ограничение или попробуйте ещё раз.",
    session_expired: "Сессия истекла. Зайдите на учетную запись снова.",
    header_sign_out: "Выйти из учетной записи",
    header_login: "Зайти в учетную запись",
    header_help: "Помощь",
    welcome_header: "Добро пожаловать в программу подбора оборудования Philips",
    welcome_copy: "С программой подбора Philips, легко можно найти Philips-альтернативу любой лампы или ПРА.",
    welcome_feature_1: "Быстро найти ваш продукт/продукты",
    welcome_feature_2: "Простой поиск и вывод результатов",
    welcome_feature_3: "Получение всей информации и спецификации, необходимой для замены продукта",
    login_title: "Зайти в учетную запись",
    login_form_username: "Имя пользователя",
    login_form_password: "Пароль",
    login_form_remember: "Оставаться онлайн",
    login_form_forgot_pswd: "Забыли пароль?",
    login_form_login: "Зайти в учетную запись",
    login_no_account_yet: "У Вас нет учетной записи?",
    login_request_account: "Зарегистрировать учетную запись",
    login_skip_request_explanation: "Если не заходить в систему, у вас есть возможность нахождения продуктов, но с ограниченным функционалом. Не будет доступна следующая информация",
    login_skip_login_cta: "Не использовать учетную запись",
    login_credentials_invalid: "Адрес эл. Почты или пароль неверны.",
    login_forgot_pswd: "Забыл пароль",
    login_forgot_pswd_content_one: "Вы забыли пароль? Всё хорошо, введите ваш адрес эл. Почты, привязанный к учетной записи",
    login_forgot_pswd_content_two: "Если Вы зарегистрированы, мы вышлем Вам ссылку для сброса.",
    login_forgot_pswd_email: "Адрес эл. Почты",
    login_forgot_request_pswd: "Запросить новый пароль",
    login_forgot_invalid: "Некорректный адрес эл. Почты",
    login_successful: "Успешный вход в учетную запись",
    logout_successful: "Успешный выход из учетной записи",
    home_search_for_product: "Поиск продукта",
    home_title: "Как это работает?",
    home_subtitle: "Oчень просто.",
    home_content_one: "Новый поиск позволит вам подобрать замену из ассортимента Philips устаревшему световому оборудованию.",
    home_content_two: "Введите код или описание, чтобы получить список возможных замен. Если у вас нет этой информации, используйте фильтры для поиска нужного продукта.",
    home_content_three: "После выбора продукта вы можете проверить и скачать всю информацию.",
    home_contact_us: "Свяжитесь с нами",
    request_account_title: "Запросить создание учетной записи",
    request_account_content_one: "С учетной записью у Вас будет полный доступ к нашей поисковой программе, включая дополнительные функции по выгрузке, множественный ввод, ввод по спецификации и неограниченный поиск",
    request_account_content_two: "Чтобу подтвердить учетную запись, нам требуется базовая информация о компании",
    request_account_content_three: "После подтверждения, вы получите ссылку на создание учетной записи",
    request_account_personal_information: "Персональная информация",
    request_account_first_name: "Имя пользователя",
    request_account_last_name: "Фамилия",
    request_account_email: "Почтовый адрес",
    request_account_username: "(Это будет ваше имя пользователя)",
    request_account_password_1: "Пароль",
    request_account_password_2: "Повторить пароль",
    request_account_company: "Компания",
    request_account_company_name: "Имя компании",
    request_account_country: "Страна",
    request_account_job: "Должность",
    agree_to_privacy_policy: "Я прочитал и согласен с политикой неразглашения данных и условиями пользования",
    validate_all_fields_required: "Все поля обязательны.",
    validate_agree_tac: "Вы должны согласиться с условиями и требованиями",
    validate_passwords_dont_match: "Пароли не совпадают",
    validate_password_too_short: "Пароль должен быть не менее 8 символов",
    validate_password_too_weak: "Пароль не достаточно безопасный",
    email_already_in_use: "Уже есть пользователь с таким адресом эл. Почты",
    email_verify_in_progress: "Проверяем Ваш адрес эл. Почты",
    email_verified_success: "Ваш почтовый адрес успешно подтвержден. Вы можете зайти в свою учетную запись",
    email_verified_failed: "Мы сожалеем, мы не смогли подтвердить Ваш почтовый адрес",
    registration_successful: "Подтверждение адреса эл. Почты было отправлено на ваш адрес электронной почты",
    password_reset_failed: "Возникла ошибка, попробуйте ещё раз позже",
    password_reset_email_sent: "Мы отправили Вам ссылку для установки нового пароля",
    new_password_header: "Выберите новый пароль",
    new_password: "Новый пароль",
    repeat_new_password: "повторите новый пароль",
    save_new_password: "Сохранить новый пароль",
    password_changed_success: "Пароль успешне заменен",
    request_account_request: "Запросить создание учетной записи",
    visual_input_code_title: "Введите код продукта/описание",
    visual_input_code_content: "Введите название продукта, код, или поиск с фильтрами.",
    visual_hit_search_title: "Нажмите кнопку поиска",
    visual_hit_search_content: "Введите название или код продукта.",
    visual_select_result_title: "Изучите результаты подбора",
    visual_select_result_content: "Просмотрите весь список и подберите наиболее подходящую замену из продукции Philips.",
    search_input: "Напишите (часть) кода или описание",
    search_submit: "Искать продукт",
    search_filter_product_type: "Тип продукта",
    search_filter_device: "Устройство",
    search_filter_color: "Цвет",
    search_filter_wattage: "Мощность",
    search_filter_brand: "Бренд",
    search_filter_show_all: "Показать все фильтры",
    search_filter_hide_all: "Спрятать все фильтры",
    search_filter_clear_all: "Очистить все фильтры",
    results_export: "Выгрузить результаты",
    result_export_all: "Выгрузить все результаты",
    results: "результаты",
    results_shown: "Результаты",
    no_results_found: "Результаты не найдены, попробуйте другой способ поиска.",
    results_no_recommendations: "Застряли? Свяжитесь с вашим менеджером для решения проблемы",
    recommendations_singular: "рекомендация",
    recommendations_plural: "рекомендации",

    home_contact_us_content: "Should you require any further information or if you have any questions, feel free to contact us and we will be glad to assist you.",
    home_contact_us_first_name: "Имя пользователя",
    home_contact_us_last_name: "Фамилия",
    home_contact_us_email: "Почтовый адрес",
    home_contact_us_message: "Message",
    home_contact_us_submit: "Submit",
    home_contact_us_successfully: "Your message is successfully sent.",
    home_contact_us_error: "Something went wrong, please try again.",
    usage_disclaimer: "Intended only for the use of qualified Philips customers.",
    search_filter_bulb_finish: "Bulb finish",
    search_filter_bulb: "Bulb",
    search_filter_ignitor: "Ignitor",
    search_filter_packaging_configuration: "Packaging configuration",
    search_filter_fixture_feature: "Fixture feature",
    search_filter_base: "base",
    total_number_results: "Total number of results",
    results_specify: "Более 10 подходящих продуктов, уточните поиск для получения более точного результата.",

    //facets
    brand: "Бренд",
    discrete_wattage: "Мощность",
    wattage: "Мощность",
    type: "Type",
    color: "Цвет",
    bulb_finish: "Bulb finish",
    subfamily: "Subfamily",
    bulb: "Bulb",
    ignitor: "Ignitor",
    packaging_configuration: "Packaging configuration",
    fixture_feature: "Fixture feature",
    family: "Family",
    base: "Base",
    pf_cap: "PF cap",
    number_of_lamps: "Number of lamps",
    lamp_current: "Lamp current",
    mains_frequency: "Mains frequency",
    driver_type: "Driver type",
    mains_voltage: "Mains voltage",
    height: "Height",
    weight: "Weight",
    thermal_protection: "Thermal protection",
    losses: "Losses",
    temp_range: "Temperature range",
    delta_temperature: "Delta temperature",
    life_class_tw: "Life class TW",
    wiring_diagram: "Wiring diagram",
    width: "Width",
    length: "Length",
    type_of_lamp: "Type of lamp",
    mounting_hole: "Mounting hole",
    power_factor: "Power factory",
    energy_efficiency: "Energy efficiency",
    energy_saving: "Сохранение энергии",

    //Match and result props
    apr: "APR",
    ean: "EAN",
    eu: "EU",
    latam: "Latam",
    material_description: "Material description",
    nam: "NAM",
    product_code: "Product code",
    remark: "Remark",
    valid: "Valid",

    card_action: "Характеристики",
    card_perfect_fit: "Philips Best Fit",
    card_alternative_fit: "Philips Best Alternative",
    card_show_more: "Show more",
    card_show_less: "Show less",

    lamp: "Светильник или лампа",
    driver: "Драйвер"
};
